import { useState } from "react";

export const FileUploader = ({ attribute, id, placeholder = null, label = null, required = false, onFileLoad, accept = "image/*" }) => {
    const [preview, setPreview] = useState(null);

    const handleChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            const blobString = reader.result;
            setPreview(blobString);
            onFileLoad(blobString, file);
        };
        reader.readAsDataURL(file);
    };

    return (
        <div>
            {label && <label htmlFor={id} className="block text-lg font-medium text-gray-700">
                {label} {required === true && "*"}
            </label>}
            <input
                type="file"
                accept={accept}
                onChange={handleChange}
                label={label}
                id={id}
                placeholder={placeholder}
                required={required}
            />
            {(preview || attribute) && (
                <img
                    src={preview ? preview : attribute ? attribute : ""}
                    alt="Preview"
                    style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8, marginTop: 8 }}
                />
            )}
        </div>
    );
};